import { render, staticRenderFns } from "./CodeMng.vue?vue&type=template&id=5b79dfec&scoped=true"
import script from "./CodeMng.vue?vue&type=script&lang=js"
export * from "./CodeMng.vue?vue&type=script&lang=js"
import style0 from "./CodeMng.vue?vue&type=style&index=0&id=5b79dfec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b79dfec",
  null
  
)

export default component.exports